import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../../services/langRegister";
import {marketRegister} from "../../../services/marketRegister";
import {salesChannelRegister} from "../../../services/salesChannelRegister";
import {dataRegister} from "../../../services/dataRegister";

class HomeSectionsEight extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        let items = [
            {
                title: this._renderText("item_1"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_2"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_3"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_4"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_5"),
                adbop: {exist: true, value: this._renderText("item_15")},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_6"),
                adbop: {exist: true, value: this._renderText("item_15")},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_7"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: false, value: ""}
            },
            {
                title: this._renderText("item_8"),
                adbop: {exist: true, value: "Beta"},
                adwords: {exist: false, value: ""}
            },
            {
                title: this._renderText("item_9"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: false, value: ""}
            },
            {
                title: this._renderText("item_10"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: false, value: ""}
            },
            {
                title: this._renderText("item_11"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: false, value: ""}
            },
            {
                title: this._renderText("item_12"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: false, value: ""}
            },
            {
                line: true,
                title: this._renderText("item_13"),
                adbop: {exist: false, value: this._renderText("item_17")},
                adwords: {exist: false, value: this._renderText("item_18")}
            },
            {
                title: this._renderText("item_14"),
                adbop: {exist: false, value: this._renderText("item_17")},
                adwords: {exist: false, value: this._renderText("item_18")}
            },
            {
                title: this._renderText("item_19"),
                adbop: {exist: false, value: this._renderText("item_17")},
                adwords: {exist: false, value: this._renderText("item_18")}
            },
            {
                line: true,
                title: this._renderText("item_22"),
                adbop: {exist: false, value: this._renderText("item_20")},
                adwords: {exist: false, value: this._renderText("item_21")}
            }
        ];
        this.setState({items: items});
    }

    _lisIndustries(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }
    }

    _renderText(item) {
        return langRegister.get("home-sections-eight", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.table}>
                        <div className={cx(Styles.tableItem)}>
                            <div className={Styles.tableSectionOne}/>
                            <div className={cx(Styles.tableSectionTwo, Styles.tableItemTop)}>
                                <div className={Styles.tableTitle}>
                                    adBop
                                </div>
                            </div>
                            <div className={cx(Styles.tableSectionThree)}>
                                <div className={Styles.tableTitle}>
                                    {this._renderText("item_16")}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.items.map((item) => {
                                return(
                                    <div className={
                                        cx(Styles.tableItem,
                                            {
                                                [Styles.tableItemLine]: item.line,
                                            })
                                    } >
                                        <div className={Styles.tableSectionOne}>
                                            <div className={Styles.tableSectionOneTitle}>
                                                {item.title}
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionTwo,
                                                {
                                                    [Styles.tableSectionTwoActive]: item.adbop.exist,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitle}>
                                                {item.adbop.value}
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionThree,
                                                {
                                                    [Styles.tableSectionThreeActive]: item.adwords.exist,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitle}>
                                                {item.adwords.value}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div onClick={() => this._lisIndustries()} className={Styles.button}>
                        {this._renderText("item_23")}
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeSectionsEight;


// WEBPACK FOOTER //
// ./src/components/home-sections/eight/component.js